export const AuthLayoutContainer = (props) => {
    return <>
        {props.children}
    </>;
};
